import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';

import { SharedModule } from '@app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

import { ChangeStepService } from '@app/core/components/stepper/service/change-step.service';
import { ChangeDeviceService } from '@app/shared/services/change-device.service';
import { SaveDataService } from '@app/shared/services/save-data.service';
import { AppService } from '@app/app.service';

@Component({
    selector: 'app-authentication',
    standalone: true,
    imports: [CommonModule, SharedModule, TranslateModule],
    templateUrl: './authentication.component.html',
    styleUrl: './authentication.component.scss',
})
export class AuthenticationComponent {

	private appData = inject(AppService);
	private saveDataService = inject(SaveDataService);

    continueButton = 'common.buttons.continueButton';
    backButton = 'common.buttons.backButton';

    authTitle = 'features.authentication.authTitle';
    authSubtitle = 'features.authentication.authSubtitle1';

    authStep1 = 'features.authentication.authStep1';
    authStep2 = 'features.authentication.authStep2';
    authStep3 = 'features.authentication.authStep3';

    backButtonDisabled = false;
    continueButtonDisabled = true;

    isPortraitDevice = false;

    formGroup!: FormGroup;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private changeDeviceService: ChangeDeviceService,
        private changeStepService: ChangeStepService,
        private fb: FormBuilder,
    ) {
        this.changeStepService.changeStep(23);
    }

    ngOnInit() {
        this.isPortraitDevice = this.changeDeviceService.isPortraitDevice;
        this.changeDeviceService.changedDevice.subscribe((value) => {
            this.isPortraitDevice = value;
        });

        this.createForm();
        this.setValuesForm(this.appData.data.userData);

        this.formIsValid();
    }

    createForm() {
        this.formGroup = this.fb.group({});
    }

    setValuesForm(value?: any) {
        if (value != undefined) {
            this.formGroup = this.fb.group({});
        }
    }

    //-------------------------//
    //------EVENT METHODS------//
    //-------------------------//


    //-------------------------//
    //-------VALIDATION--------//
    //-------------------------//

    formIsValid() {
        this.continueButtonDisabled = !this.formGroup.valid;
    }

    //-------------------------//
    //--------NAVIGATION-------//
    //-------------------------//

    onClicButtonBack() {
        this.createForm();
        this.saveDataService.saveDataLocal(this.formGroup.value, 'authentication');
        //this.router.navigate(['/main/co-holder'], { relativeTo: this.route });
        this.router.navigate(['/main/step/recruitment'], { relativeTo: this.route });
    }

    onClicButtonContinue() {
        this.saveDataService.saveDataLocal(this.formGroup.value, 'authentication');
        this.router.navigate(['/main/step/authentications/authentication-data'], { relativeTo: this.route });
    }

    ngOnDestroy() {}
}
